import LoadingSkeleton from 'components/LoadingSkeleton';
import SectionDivider from 'screens/ClubOverview/components/SectionDivider';
import { useUpcomingPrograms } from '../UpcomingPrograms/useUpcomingPrograms';
import { useVenueCoaches } from '../VenueCoaches/useVenueCoaches';

interface Props {
  venueId: string;
  followersCount: number;
}

interface StatCard {
  label: string;
  count: number;
  iconSrc: string;
}

export default function VenueStats({ venueId, followersCount }: Props) {
  // Same queries as the sections above — Apollo dedupes identical in-flight
  // queries, so these piggyback on the section fetches instead of refetching.
  const { programs, isLoading: isProgramsLoading } = useUpcomingPrograms({ venueId });
  const { coaches, isLoading: isCoachesLoading } = useVenueCoaches({ venueId });

  const isLoading = isProgramsLoading || isCoachesLoading;

  const cards: StatCard[] = [
    { label: 'Programs', count: programs.length, iconSrc: '/images/programming/open-play.png' },
    { label: 'Coaches', count: coaches.length, iconSrc: '/images/app/cap-colored.png' },
    { label: 'Followers', count: followersCount, iconSrc: '/images/app/individual.svg' },
  ];

  return (
    <>
      <SectionDivider className="my-ds-3xl" />
      {isLoading ? (
        <LoadingSkeleton
          count={3}
          height="7rem"
          borderRadius="1.5rem"
          containerClassName="flex gap-ds-md [&>span]:flex-1"
        />
      ) : (
        <div className="flex gap-ds-md">
          {cards.map((card) => (
            <div
              key={card.label}
              className="flex min-w-0 flex-1 flex-col gap-ds-lg rounded-3xl border border-color-border-input-lightmode bg-color-bg-lightmode-primary px-ds-xl pb-ds-lg pt-ds-xl shadow-[0px_4px_16px_rgba(0,0,0,0.08)] dark:border-color-border-input-darkmode dark:bg-color-bg-darkmode-secondary"
            >
              <h3 className="typography-product-subheading text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
                {card.label}
              </h3>
              <div className="flex items-start gap-ds-xs">
                <span className="typography-product-heading text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
                  {card.count.toLocaleString('en-US')}
                </span>
                <img src={card.iconSrc} alt="" className="size-6 object-contain" />
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
